import { cn } from '@/utils/cn';

export const TikTokLogo = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={cn('w-6', className)}
			viewBox="0 0 20 20"
			fill="none"
		>
			<path
				d="M17.5 5.47179C16.4211 5.43925 15.4436 4.92232 14.7064 4.23142C14.3035 3.84757 13.9843 3.38458 13.7689 2.87152C13.5536 2.35845 13.4466 1.80638 13.4547 1.25H10.4508V12.8202C10.4508 14.7102 9.31802 15.8242 7.92619 15.8242C7.55713 15.8282 7.19167 15.7513 6.85554 15.5988C6.5194 15.4464 6.22076 15.2222 5.98061 14.9419C5.74046 14.6616 5.56466 14.3321 5.46557 13.9766C5.36648 13.6211 5.34652 13.2482 5.40707 12.8841C5.46762 12.5199 5.60723 12.1735 5.81608 11.8693C6.02492 11.5649 6.29792 11.3101 6.61585 11.1227C6.93379 10.9352 7.28893 10.8197 7.65631 10.7843C8.02369 10.7489 8.39437 10.7944 8.74226 10.9177V7.86243C8.47428 7.8035 8.20056 7.77454 7.92619 7.77607C6.8332 7.77582 5.76468 8.0997 4.85576 8.70676C3.94685 9.31382 3.23837 10.1768 2.81993 11.1865C2.40148 12.1962 2.29188 13.3074 2.50496 14.3794C2.71804 15.4514 3.24424 16.4362 4.01702 17.2091C4.7898 17.9821 5.77443 18.5084 6.84641 18.7219C7.91838 18.9352 9.02955 18.8258 10.0394 18.4076C11.0492 17.9893 11.9123 17.2811 12.5195 16.3723C13.1268 15.4636 13.4509 14.3951 13.4509 13.3021V7.07516C14.6149 7.87997 16.0055 8.26046 17.49 8.28675L17.5 5.47179Z"
				fill="currentColor"
			/>
		</svg>
	);
};
